import { W as WuiInputMenu$1, d as defineCustomElement$1 } from './p-DECjeigc.js';

const WuiInputMenu = WuiInputMenu$1;
const defineCustomElement = defineCustomElement$1;

export { WuiInputMenu, defineCustomElement };
